import { supabase, applyOrgFilter, getActiveOrgOverride } from '../supabaseClient'
import { getCurrentStaff } from './auth'
import { getStaffGroups, getAllGroups } from './groups'
import { getAsistenciasCountsBySesiones } from './sessions'
import { getAsistenciasCountByJuegoIds } from './games'
import { getMexicoDateString } from '../dateUtils'
import { buildAgendaHoy } from '../agendaHoy'

const ROLES_TODO = ['admin', 'head_coach', 'platform_admin']

export const getAgendaHoy = async () => {
  try {
    const { data: staff } = (await getCurrentStaff()) || {}
    const hoy = getMexicoDateString()

    // platform_admin sin org activa (sin impersonar) no tiene "agenda de hoy":
    // evita traer TODOS los grupos de TODAS las orgs (RLS de platform_admin),
    // que cuelga la pantalla. Al impersonar una org si funciona normal.
    if (staff?.rol === 'platform_admin' && !getActiveOrgOverride()) {
      return { data: { items: [], grupos: [] }, error: null }
    }

    // Grupos del usuario segun rol.
    let grupos = []
    if (staff?.rol && ROLES_TODO.includes(staff.rol)) {
      const { data } = await getAllGroups()
      grupos = (data || [])
        .filter((g) => (g.estatus || '').toLowerCase() === 'activo' || !g.estatus)
        .map((g) => ({ id: g.id, nombre: g.nombre_del_grupo }))
    } else {
      const { data } = await getStaffGroups(staff?.id)
      grupos = (data || [])
        .map((sg) => sg.grupos)
        .filter(Boolean)
        .map((g) => ({ id: g.id, nombre: g.nombre_del_grupo }))
    }
    const grupoIds = grupos.map((g) => g.id)
    const gruposById = Object.fromEntries(grupos.map((g) => [g.id, g.nombre]))

    if (grupoIds.length === 0) {
      return { data: { items: [], grupos: [] }, error: null }
    }

    // Sesiones de entrenamiento de hoy.
    let sesQ = supabase
      .from('sesiones')
      .select('id, grupo_id, fecha, tipo, hora_inicio, titulo, estatus')
      .in('grupo_id', grupoIds)
      .eq('fecha', hoy)
      .eq('tipo', 'entrenamiento')
    sesQ = applyOrgFilter(sesQ)
    const { data: sesiones, error: sesErr } = await sesQ
    if (sesErr) throw sesErr

    // Juegos de hoy.
    let jueQ = supabase
      .from('juegos')
      .select('id, grupo_id, fecha, hora, estatus, equipo_nombre, torneo:torneos(nombre)')
      .in('grupo_id', grupoIds)
      .eq('fecha', hoy)
      .eq('activo', true)
      .is('deleted_at', null)
    jueQ = applyOrgFilter(jueQ)
    const { data: juegos, error: jueErr } = await jueQ
    if (jueErr) throw jueErr

    const { data: sesionCounts } = await getAsistenciasCountsBySesiones((sesiones || []).map((s) => s.id))
    const { data: juegoCounts } = await getAsistenciasCountByJuegoIds((juegos || []).map((j) => j.id))

    const items = buildAgendaHoy({
      sesiones: sesiones || [],
      juegos: juegos || [],
      gruposById,
      sesionCounts: sesionCounts || {},
      juegoCounts: juegoCounts || {},
    })

    return { data: { items, grupos }, error: null }
  } catch (error) {
    console.error('[getAgendaHoy]', error)
    return { data: { items: [], grupos: [] }, error }
  }
}
